module.exports = __webpack_public_path__ + "img/Syg_icon_tuis.58c91498.png";